import axios from "../../utilis/axios";

export const getTags = async () => {
  const res = await axios.get("/tags");
  return res.data;
};
